import getScreenType from '@/utils/analytics/getScreenType';
import getUploadAnalyticsSettings from '@/utils/analytics/getUploadAnalyticsSettings';
import sendAiGenScreenActionAnalytics from '@/utils/analytics/sendAiGenScreenActionAnalytics';
import { AiGenScreenAction } from '@/types/analytics';

/** Send analytics for an upload confirmed on CDN (after success). */
const sendUploadAnalytics = () => {
  sendAiGenScreenActionAnalytics({
    action: AiGenScreenAction.UPLOAD,
    screen_type: getScreenType(),
    settings: getUploadAnalyticsSettings(),
  });
};

export default sendUploadAnalytics;
